export default __webpack_public_path__ + "3a802dcc979bbda3a9a76cf43f349d2e.jpg";